// ChatPage.js
import React, { useEffect, useState } from 'react'
import {
  collection,
  doc,
  getDoc,
  getDocs,
  onSnapshot,
  orderBy,
  query,
  addDoc,
  setDoc,
  updateDoc,
  serverTimestamp,
  deleteDoc,
} from 'firebase/firestore'
import { db } from '../firebaseConfig'

// [BARU] Import komponen ChatRoom lama untuk sementara.
import ChatRoomUser from './ChatRoomUser'
import ChatRoomMitra from './ChatRoomMitra'

// Tambahkan props contactToOpen
export default function ChatPage({ openChat: openChatFromParent, contactToOpen }) {
  const [activeChats, setActiveChats] = useState({ mitra: [], user: [] })

  // [BARU] Listener: Jika ada kontak yang dikirim dari Modal InboxPage, langsung buka chatnya
  useEffect(() => {
    if (contactToOpen) {
      openContactChat(contactToOpen)
    }
  }, [contactToOpen])
  const [mitraList, setMitraList] = useState([])
  const [userList, setUserList] = useState([]) 
  // --- UBAH KODE: Tambahkan tab default untuk filter driver ---
  const [activeTab, setActiveTab] = useState('driver_motor') // Pilihan tab: 'driver_motor', 'driver_mobil', 'mitra', 'user'
  const [searchTerm, setSearchTerm] = useState('')
  const [activeChat, setActiveChat] = useState(null)

  // LISTEN DAFTAR CHAT (User + Mitra)
  useEffect(() => {
    const q = query(collection(db, 'chats'), orderBy('lastTimestamp', 'desc'))
    const unsub = onSnapshot(q, (snap) => {
      const mitraList = []
      const userList = []

      snap.docs.forEach((d) => {
        const docData = d.data()
        
        // Mencegah render data sampah (baris kosong/tanpa ID)
        if (!docData.userId && !docData.mitraId) return;

        const isUser = !d.id.startsWith('admin_') 
        
        const chatItem = { 
          id: d.id, 
          displayName: isUser ? (docData.userName || 'User App') : docData.mitraName,
          realId: isUser ? docData.userId : docData.mitraId,
          ...docData 
        }

        if (isUser) {
          userList.push(chatItem)
        } else {
          mitraList.push(chatItem)
        }
      })
      
      setActiveChats({ mitra: mitraList, user: userList })
    })
    return () => unsub()
  }, [])

  // Update fungsi openChatWithMitra agar kompatibel (Opsional, untuk list manual)
  // ... (Kode lain tetap sama)

  // Ubah bagian render List agar menggunakan 'displayName'
  // Di dalam map((c) => ...
  /* GANTI: <div className="font-medium">{c.mitraName}</div> 
     JADI:  <div className="font-medium">{c.displayName}</div>
  */

  // ===========================================================
  // ===========================================================
  // LOAD LIST MITRA & USERS
  // ===========================================================
  useEffect(() => {
    async function fetchData() {
      // 1. Ambil Mitra (Terapis, Cleaner, dan DRIVER)
      const th = await getDocs(collection(db, 'therapists'))
      const cl = await getDocs(collection(db, 'cleaners'))
      const dr = await getDocs(collection(db, 'drivers')) // --- TAMBAHAN KODE: Panggil data driver ---

      const allMitra = [
        ...th.docs.map((d) => ({
          id: d.data().id_number, 
          name: d.data().name,
          type: 'mitra'
        })),
        ...cl.docs.map((d) => ({
          id: d.data().id_number,
          name: d.data().name,
          type: 'mitra'
        })),
        // --- TAMBAHAN KODE: Gabungkan data driver ke dalam list Mitra Admin ---
        ...dr.docs.map((d) => ({
          id: d.id, // Driver menggunakan UID Firestore
          name: d.data().name || 'Driver Zimo',
          type: 'mitra'
        })),
      ]
      setMitraList(allMitra)

      // 2. [BARU] Ambil Users (Pelanggan)
      const us = await getDocs(collection(db, 'users'))
      const allUsers = us.docs.map((d) => ({
        id: d.id, // UID Firebase Auth
        name: d.data().name || d.data().displayName || d.data().username || 'User Tanpa Nama',
        email: d.data().email,
        type: 'user'
      }))
      setUserList(allUsers)
    }
    fetchData()
  }, [])

  // ===========================================================
  // OPEN CHAT (Hybrid: User & Mitra)
  // ===========================================================
  const openContactChat = async (contact) => {
    // 1. Tentukan ID Chat berdasarkan tipe kontak
    // - Jika User: Gunakan UID langsung (misal: "A1b2C3d4...")
    // - Jika Mitra: Gunakan prefix 'admin_' + id_number (misal: "admin_12345")
    const chatId = contact.type === 'user' ? contact.id : `admin_${contact.id}`
    
    // Ambil nama tampilan (fallback ke 'Tanpa Nama' jika kosong)
    const displayName = contact.name || 'Tanpa Nama'

    const chatRef = doc(db, 'chats', chatId)
    const chatSnap = await getDoc(chatRef)

    // 2. Jika dokumen chat belum ada di Firestore, buat baru
    if (!chatSnap.exists()) {
      // Tentukan data awal (Initial Data) berdasarkan tipe
      const initialData = contact.type === 'user' 
        ? {
            // --- DATA KHUSUS USER ---
            userId: contact.id,
            userName: displayName,
            userEmail: contact.email || '',
            
            // --- FIELD STANDAR ---
            lastMessage: '',
            lastTimestamp: serverTimestamp(),
            status: 'bot_mode', // User baru default-nya bot mode
            waiting: false,
            sessionActive: false,
            openedByAdmin: false,
            unreadByAdmin: 0,
          }
        : {
            // --- DATA KHUSUS MITRA ---
            mitraId: contact.id,
            mitraName: displayName,
            
            // --- FIELD STANDAR ---
            lastMessage: '',
            lastTimestamp: serverTimestamp(),
            sessionActive: false, // Mitra default-nya tidak aktif
            waiting: false,
            openedByAdmin: false,
            currentSessionId: null, // Mitra butuh session ID
          }

      // Simpan ke Firestore
      await setDoc(chatRef, initialData, { merge: true })
    }

    // 3. Set Active Chat di State (Agar Panel Kanan Terbuka)
    setActiveChat({
      id: chatId,
      displayName: displayName,
      isUser: contact.type === 'user',
      realId: contact.id
    })
    
    // 4. Panggil fungsi parent (jika ada) untuk kompatibilitas
    if (typeof openChatFromParent === 'function') {
      openChatFromParent(displayName, chatId)
    }
  }
  // ===========================================================
  // ADMIN → OPEN SESSION (Hybrid: User & Mitra)
  // ===========================================================
  // Ubah parameter dari mitraId menjadi docId (ID Dokumen aslinya)
  const openSession = async (docId) => {
    // Cek apakah ini User (tidak ada prefix admin_)
    const isUser = !docId.startsWith('admin_')
    
    const chatRef = doc(db, 'chats', docId)

    if (isUser) {
      // LOGIKA USER: Ubah status jadi 'open' sesuai request
      await updateDoc(chatRef, { 
        status: 'open', 
        waiting: false, // Hilangkan badge waiting
        sessionActive: true, 
        openedByAdmin: true 
      })
      // Kirim pesan sistem bahwa admin bergabung
      await addDoc(collection(db, 'chats', docId, 'messages'), {
        text: 'Admin telah bergabung dalam chat.',
        senderId: 'system',
        createdAt: serverTimestamp(),
        type: 'system',
        isAdmin: true
      })
      alert("Sesi User DIBUKA (Status: OPEN). Silakan chat.")
    } else {
      // ✅ LOGIKA MITRA: Buat Session Baru (Kode Lama)
      const snap = await getDoc(chatRef)
      if (!snap.exists()) return

      const data = snap.data()
      let sessionId = data?.currentSessionId

      if (!sessionId) {
        sessionId = `S_${Date.now()}`
        await setDoc(
          doc(db, 'chats', docId, 'sessions', sessionId),
          { startedAt: serverTimestamp(), endedAt: null },
          { merge: true }
        )
        await updateDoc(chatRef, { currentSessionId: sessionId })
      }

      await setDoc(chatRef, {
        sessionActive: true,
        openedByAdmin: true,
        waiting: false,
        lastTimestamp: serverTimestamp(),
      }, { merge: true })

      await addDoc(
        collection(db, 'chats', docId, 'sessions', sessionId, 'messages'),
        {
          senderId: 'system',
          text: 'Admin telah memulai sesi chat.',
          timestamp: serverTimestamp(),
        }
      )
    }
  }

  // ===========================================================
  // ADMIN → CLOSE SESSION (Hybrid: User & Mitra)
  // ===========================================================
  const closeSession = async (docId) => {
    const isUser = !docId.startsWith('admin_')
    const chatRef = doc(db, 'chats', docId)

    if (isUser) {
      // LOGIKA USER: Ubah status jadi 'closed' -> Memutus koneksi user
      await updateDoc(chatRef, { 
        status: 'closed', 
        sessionActive: false, 
        openedByAdmin: false 
      })
      alert("Sesi User DITUTUP (Status: CLOSED). Koneksi terputus.")
    } else {
      // ✅ LOGIKA MITRA: Tutup Session (Kode Lama)
      const snap = await getDoc(chatRef)
      if (!snap.exists()) return

      const data = snap.data()
      const sessionId = data?.currentSessionId
      if (!sessionId) return

      await setDoc(
        doc(db, 'chats', docId, 'sessions', sessionId),
        { endedAt: serverTimestamp() },
        { merge: true }
      )

      await setDoc(chatRef, {
        sessionActive: false,
        openedByAdmin: false,
        waiting: false,
        currentSessionId: null,
      }, { merge: true })

      await addDoc(
        collection(db, 'chats', docId, 'sessions', sessionId, 'messages'),
        {
          senderId: 'system',
          text: 'Sesi chat ditutup oleh admin.',
          timestamp: serverTimestamp(),
        }
      )
    }
  }

  // ===========================================================
  // ADMIN → DELETE CHAT DARI DAFTAR (List Aktif)
  // ===========================================================
  const handleDeleteChat = async (e, chatId) => {
    e.stopPropagation() // Mencegah klik tembus yang membuat panel chat malah terbuka
    
    if (!window.confirm("Yakin ingin menghapus riwayat obrolan ini dari daftar?")) return

    try {
      await deleteDoc(doc(db, 'chats', chatId))
      
      // Jika chat yang dihapus kebetulan sedang dibuka di panel kanan, tutup panelnya
      if (activeChat?.id === chatId) {
        setActiveChat(null)
      }
    } catch (err) {
      console.error("Gagal menghapus chat:", err)
      alert("Terjadi kesalahan saat menghapus chat.")
    }
  }

  // ===========================================================
  // FILTER PENCARIAN (SESUAI TAB AKTIF)
  // ===========================================================
  const targetList = activeTab === 'mitra' ? mitraList : userList
  
  const filteredContacts = targetList.filter((c) =>
    c.name.toLowerCase().includes(searchTerm.toLowerCase())
  )

  return (
    <div className="flex h-[80vh] bg-gray-950 text-gray-200 rounded-xl shadow-lg overflow-hidden">
      {/* LEFT SIDEBAR */}
      <div className="w-1/3 border-r border-gray-800 bg-gray-900 overflow-y-auto">
        <div className="p-4 font-semibold text-gray-200 border-b border-gray-800">
          Daftar Percakapan & Mitra
        </div>

        {/* Search */}
        <div className="p-3 border-b border-gray-800">
          <input
            type="text"
            placeholder="Cari nama mitra..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full bg-gray-950 border border-gray-800 rounded-lg px-3 py-2 text-sm"
          />
        </div>

        {/* List chat */}
        <div className="p-2">
          <div className="text-xs text-gray-600 px-2 py-1 mb-2 border-b border-gray-800 pb-2">
            Chat Aktif ({activeTab === 'mitra' ? 'Mitra' : 'User'})
          </div>

          {/* Gunakan data array sesuai tab yang aktif */}
          {(activeTab === 'mitra' ? activeChats.mitra : activeChats.user).map((c) => (
            <div
              key={c.id}
              onClick={() =>
                setActiveChat({
                  id: c.id,
                  displayName: c.displayName,
                  isUser: activeTab === 'user', // Menandai tipe chat yang diklik
                  realId: c.realId
                })
              }
              className={`p-3 border-b border-gray-800 cursor-pointer flex justify-between items-center ${
                activeChat?.id === c.id ? 'bg-gray-800' : 'hover:bg-gray-900'
              }`}
            >
              <div className="flex-1">
                <div className="font-medium text-gray-200">{c.displayName}</div>
                <div className="text-xs text-gray-500 truncate max-w-[130px]">{c.lastMessage}</div>
              </div>

              {/* BUNGKUSAN BARU UNTUK BADGE & TOMBOL HAPUS */}
              <div className="flex items-center gap-2">
                {/* 🔥 BADGE STATUS */}
                {c.waiting === true && (
                  <span className="px-2 py-1 bg-red-600 text-white text-[10px] rounded-md">
                    MENUNGGU
                  </span>
                )}

                {c.sessionActive === true && (
                  <span className="px-2 py-1 bg-green-600 text-white text-[10px] rounded-md">
                    AKTIF
                  </span>
                )}

                {!c.sessionActive && c.waiting === false && (
                  <span className="px-2 py-1 bg-gray-700 text-gray-300 text-[10px] rounded-md">
                    TERTUTUP
                  </span>
                )}

                {/* TOMBOL HAPUS */}
                <button
                  onClick={(e) => handleDeleteChat(e, c.id)}
                  className="px-2 py-1 text-gray-500 hover:text-red-500 hover:bg-red-500/10 rounded transition-colors"
                  title="Hapus Percakapan"
                >
                  ✕
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* ======================================= */}
        {/* TAB PILIHAN MITRA / USER (BAGIAN BAWAH) */}
        {/* ======================================= */}
        <div className="border-t border-gray-800 mt-2" />
        
        {/* Tab Switcher */}
        <div className="flex p-2 gap-2">
          <button 
            onClick={() => setActiveTab('mitra')}
            className={`flex-1 py-1 text-xs rounded border ${activeTab === 'mitra' ? 'bg-gray-800 border-gray-600 text-white' : 'border-transparent text-gray-500 hover:bg-gray-900'}`}
          >
            Mitra
          </button>
          <button 
            onClick={() => setActiveTab('user')}
            className={`flex-1 py-1 text-xs rounded border ${activeTab === 'user' ? 'bg-gray-800 border-gray-600 text-white' : 'border-transparent text-gray-500 hover:bg-gray-900'}`}
          >
            User
          </button>
        </div>

        {/* List Kontak */}
        <div className="p-2">
          <div className="text-xs text-gray-600 px-2 py-1 mb-1">
            {activeTab === 'mitra' ? 'Daftar Mitra' : 'Daftar User'}
          </div>

          {filteredContacts.map((contact) => (
            <div
              key={contact.id}
              // ✅ PERBAIKAN: Variabel loop 'contact' dipanggil dengan benar di sini
              onClick={() => openContactChat(contact)} 
              className="p-3 border-b border-gray-800 cursor-pointer hover:bg-gray-900 flex justify-between items-center"
            >
              <div className="overflow-hidden">
                <div className="font-medium truncate">{contact.name}</div>
                <div className="text-xs text-gray-600 truncate">
                  {/* Tampilkan ID jika mitra, Email jika user */}
                  {activeTab === 'mitra' ? contact.id : contact.email}
                </div>
              </div>
              <button className="text-xs px-2 py-1 bg-gray-800 rounded border border-gray-700 text-gray-300">
                Chat
              </button>
            </div>
          ))}
          
          {filteredContacts.length === 0 && (
            <div className="text-center text-xs text-gray-600 py-4">
              Tidak ditemukan.
            </div>
          )}
        </div>
      </div>

      {/* RIGHT PANEL */}
      <div className="flex-1 flex flex-col bg-gray-950">
        {!activeChat ? (
          <div className="flex items-center justify-center text-gray-600 h-full">
            Pilih percakapan
          </div>
        ) : activeChat.isUser ? (
          <ChatRoomUser 
             userName={activeChat.displayName} 
             chatId={activeChat.id} 
             onBack={() => setActiveChat(null)} 
          />
        ) : (
          <ChatRoomMitra 
             mitraName={activeChat.displayName} 
             chatId={activeChat.id} 
             onBack={() => setActiveChat(null)} 
          />
        )}
      </div>
    </div>
  )
}
